import { Directive, HostBinding } from "@angular/core";

import { NgClassType, NgStyleType } from "../types";
import { MedLayoutService } from "../services/med-layout.service";

const STATIC_CONTENT_CLASS = "med-layout--sticky";

@Directive({
  selector: "[med-static-content]",
})
export class MedStaticContentDirective {
  constructor(private layoutSvc: MedLayoutService) { }

  @HostBinding("class") get class(): NgClassType {
    return [STATIC_CONTENT_CLASS];
  }

  @HostBinding("style") get style(): NgStyleType {
    return {
      width: this.layoutSvc.contentWidth,
      left: this.layoutSvc.offsetLeft,
    };
  }
}
